.screen {
  padding: 42px 72px;
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 30px;
}
.readiness {
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 700;
  color: var(--color-neutral-700);
}
.grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  align-content: start;
}
.card {
  padding: 26px 28px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition:
    box-shadow 0.15s,
    transform 0.15s;
}
.card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}
.card:active {
  box-shadow: var(--shadow-sm);
  transform: none;
}
.cardTop {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.arrow {
  color: var(--color-accent);
}
.name {
  margin: 12px 0 16px;
  font-weight: 800;
  color: var(--color-text);
}
.meta {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: var(--color-neutral-600);
  font-weight: 600;
}
.separator {
  color: var(--color-neutral-300);
}
